export default theme => ({
  subtitle1: {
    fontWeight: '700',
  },
  otherSubtitle: {
    fontWeight: '700',
    marginTop: '12px',
  },
  otherSubtitleSingleSelect: {
    marginTop: '24px',
  },
  card: {
    margin: '0 24px 24px 0',
    width: '100%',
  },
  showAsTableRowCard: {
    margin: '0 24px 12px 0',
  },
  noMinHeight: {
    minHeight: '0',
  },
  cardContent: {
    position: 'relative',
    overflow: 'hidden',
    padding: '0 0 0 6px',
    width: '100%',
    boxSizing: 'border-box',
  },
  cardHeader: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  cardHeaderTitle: {
    fontSize: '1rem',
    fontWeight: '700',
  },
  otherDetails: {
    marginLeft: '24px',
  },
  textField: {
    paddingRight: '12px',
    width: '100%',
    maxWidth: '300px',
  },
  questionValueWrapper: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  inputWrapper: {
    marginLeft: '4px',
    textAlign: 'left',
  },
  photoButton: {
    margin: '24px auto 0 auto',
    backgroundColor: 'var(--jmi-blue)',
    color: '#fff',
    '&:hover': {
      background: 'var(--jmi-blue-hover)',
    },
  },
  leftIcon: {
    marginRight: '12px',
  },
  removeButton: {
    backgroundColor: 'var(--jmi-red)',
    color: '#fff',
    '&:hover': {
      background: '#d2190b',
    },
    removeButtonFocused: {
      backgroundColor: '#d2190b',
    },
  },
  removeBottomPadding: {
    paddingBottom: '0 !important',
  },
  valuationButton: {
    color: '#fff',
    backgroundColor: '#71BF47',
    '&:hover': {
      background: '#4f8a30',
    },
  },
  formControl: {
    maxWidth: '400px',
  },
  tableRow: {
    width: 'auto',
    margin: '0 12px 0 0',
    padding: '0 0 10px 0',
    borderBottom: '1px solid #ededed',
  },
  overflowVisible: {
    overflow: 'visible',
  },
  cardContentRoot: {
    overflow: 'visible',
    padding: '0 !important',
  },
});
